import compileSymbols from '~/utils/compileSymbols';

var types = ['SHOW_KEYBOARD', 'HIDE_KEYBOARD'];

export default compileSymbols(types, 'keyboard');
